<template>
  <AnimatedContainer>
    <header
      class="relative flex h-[95svh] items-end overflow-hidden px-container lg:px-container-lg"
    >
      <!-- BACKGROUND IMAGE -->
      <div class="absolute inset-0">
        <AppImage
          v-if="data.image"
          :src="data.image"
          class="animate-image absolute inset-0 size-full object-cover"
          :class="'animate-image-' + data.gradient_style?.value"
          loading="eager"
          sizes="100vw"
        />
        <GradientOverlay
          :gradient-style="gradientStyle"
          class="pointer-events-none absolute inset-x-0 top-0 h-navbar-desktop rotate-180 opacity-75"
        />
        <GradientOverlay
          :gradient-style="gradientStyle"
          class="pointer-events-none absolute inset-0"
        />
      </div>

      <!-- TITLE -->
      <TextAppear
        v-if="data.heading"
        class="slide-up relative w-full pb-56 pt-20 typo-heading-xl sm:w-[88%] sm:pb-[10vh] md:typo-heading-2xl lg:typo-heading-3xl"
        tag="h1"
        :text="data.heading"
        :style="{
          '--character-appear-from': fontDark ? '#D9D5CE' : '#405382',
          '--character-appear-transition': '#D9D5CE',
          '--character-appear-to': fontDark ? '#303D5C' : '#D9D5CE',
        }"
        :duration="666"
      />
      <Scrolly
        :class="fontDark ? 'text-gray-500' : 'text-beige-500'"
        class="slide-up absolute bottom-12 right-container-md h-36 opacity-100 sm:bottom-[10vh] lg:h-40 2xl:h-48"
      />
    </header>
  </AnimatedContainer>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useNavigationStore, NavigationStyle } from '~/stores/navigation'

const { navigationStyle } = storeToRefs(useNavigationStore())

const props = defineProps({
  data: { type: Object, required: true },
})

const imageIsLight = computed(() => {
  return props.data.gradient_style?.value === 'beige'
})

const gradientStyle = computed(() => {
  return props.data.gradient_style?.value
})

const fontDark = computed(() => {
  return props.data.gradient_style?.value === 'beige'
})

onMounted(async () => {
  await nextTick()
  // Has impact on the color of the navigation
  if (imageIsLight.value) {
    navigationStyle.value = NavigationStyle.Dark
    return
  }

  navigationStyle.value = NavigationStyle.Light
})

onUnmounted(() => {
  navigationStyle.value = NavigationStyle.Dark
})
</script>

<style scoped>
.animate-image {
  animation: animate-image 12s infinite alternate ease-in-out;
}

@keyframes animate-image {
  0% {
    transform: scale(1) rotate(0);
  }

  100% {
    transform: scale(1.125) rotate(0.75deg);
  }
}
</style>
